import React from 'react';

const NotMatch = () => {
    return (
        <div>
            <h5 className="text-center text-red">No Match</h5>
        </div>
    );
};

export default NotMatch;